var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeftNative = function SvgArrowLeftNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.582 15.052"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 121",
    d: "M0 7.526a1.052 1.052 0 0 1 .31-.746L6.782.31a1.054 1.054 0 0 1 1.49 1.49L2.545 7.526l5.727 5.727a1.054 1.054 0 1 1-1.49 1.489l-6.47-6.47A1.052 1.052 0 0 1 0 7.526Z",
    fill: "#fff"
  }))));
};
export default SvgArrowLeftNative;